<mat-select [formControl]="skjemakontroll()"
            [compareWith]="erValgt"
            panelClass="velg-medlemmer--alternativer"
            [placeholder]="placeholder()"
            multiple="true"
            panelWidth="300px"
            velgAlle
            data-testid="velg-medlemmer-nedtrekksmeny"
            #medlemvelger>
  <mat-select-trigger>
    @if (skjemakontroll().value.length > 0) {
      @for (medlem of skjemakontroll().value; track medlem.id) {
        @if (medlemTemplate()) {
          <ng-container *ngTemplateOutlet="medlemTemplate()!; context: {$implicit: medlem}"/>
        } @else {
          @switch (stil()) {
            @case ('kun-avatar') {
              <avatar stil="liten" [medlem]="medlem" skjulTooltip="true"/>
            }
            @default {
              <medlem-listevisning-kompakt [medlem]="medlem"/>
            }
          }
        }
      }
    } @else {
      {{ 'Ingen valgt'|translate }}
    }
  </mat-select-trigger>
  @for (gruppe of medlemmerGruppert(); track gruppe[0]?.id) {
    <mat-optgroup [label]="gruppe[0]?.tittel || ('uten rolle'|translate) ">
      @for (innslag of gruppe[1]; track innslag.medlem.id) {
        <mat-option [value]="innslag.medlem" [disabled]="!innslag.tilgjengelig">
          @if (medlemTemplate()) {
            <ng-container *ngTemplateOutlet="medlemTemplate()!; context: {$implicit: innslag.medlem}"/>
          } @else {
            <medlem-listevisning-kompakt [medlem]="innslag.medlem"/>
          }
        </mat-option>
      }
    </mat-optgroup>
  }
</mat-select>
